import { useEffect, useState } from 'react';

// UM único timer para a página inteira (barra do topo + cupom dos dois
// seletores). O estado vive no PaywallIntl e o texto "MM:SS" é passado
// adiante — nunca existem dois relógios independentes.
export function useOfferTimer(initialSeconds = 600) {
  const [secondsLeft, setSecondsLeft] = useState(initialSeconds);
  useEffect(() => {
    const id = setInterval(() => setSecondsLeft((s) => Math.max(0, s - 1)), 1000);
    return () => clearInterval(id);
  }, []);
  return `${String(Math.floor(secondsLeft / 60)).padStart(2, '0')}:${String(secondsLeft % 60).padStart(2, '0')}`;
}

export default function OfferTimer({ label, timerLabel }) {
  return (
    <div>
      <div className="text-xs text-ink-muted leading-tight">{label}</div>
      <div className="font-display font-extrabold text-[26px] leading-tight tabular-nums">{timerLabel}</div>
    </div>
  );
}
